import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const BulgariaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'BG',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Bulgaria',
  SHORT_NAME: 'BG',

  DISPLAY_NAME: 'Bulgaria (English)',
  DISPLAY_COUNTRY: 'Bulgaria (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 42.6991007,
    INITIAL_LONGITUDE: 22.9035509,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Blagoevgrad',
    '2': 'Burgas',
    '3': 'Dobrich',
    '4': 'Gabrovo',
    '5': 'Haskovo',
    '6': 'Kardzhali',
    '7': 'Kyustendil',
    '8': 'Lovech',
    '9': 'Montana',
    '10': 'Pazardzhik',
    '11': 'Pernik',
    '12': 'Pleven',
    '13': 'Plovdiv',
    '14': 'Razgrad',
    '15': 'Ruse',
    '16': 'Shumen',
    '17': 'Silistra',
    '18': 'Sliven',
    '19': 'Smolyan',
    '20': 'Sofia City',
    '21': 'Sofia (province)',
    '22': 'Stara Zagora',
    '23': 'Targovishte',
    '24': 'Varna',
    '25': 'Veliko Tarnovo',
    '26': 'Vidin',
    '27': 'Vratsa',
    '28': 'Yambol',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-bg/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-bg/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default BulgariaLocale
